import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';
import { useAuth } from '../../../features/auth/AuthProvider';
import type { RouteItem } from '../Sidebar';

interface SidebarLinksProps {
  routes: RouteItem[];
  onClose?: () => void;
}

export default function SidebarLinks({ routes, onClose }: SidebarLinksProps) {
  const location = useLocation();
  const { admin } = useAuth();

  const activeColor = useColorModeValue('gray.700', 'white');
  const inactiveColor = useColorModeValue('secondaryGray.600', 'secondaryGray.600');
  const activeIcon = useColorModeValue('brand.500', 'white');
  const activeBg = useColorModeValue('brand.50', 'whiteAlpha.100');

  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const visibleRoutes = routes.filter((route) => {
    if (route.showInNav === false) return false;
    if (!route.roles) return true;
    return route.roles.includes(admin?.role ?? '');
  });

  return (
    <>
      {visibleRoutes.map((route) => {
        const active = isActive(route.path);
        return (
          <NavLink
            key={route.path}
            to={route.path}
            style={{ textDecoration: 'none' }}
            onClick={onClose}
          >
            <Flex
              align="center"
              w="100%"
              ps="17px"
              py="5px"
              mb="2px"
              borderRadius="15px"
              bg={active ? activeBg : 'transparent'}
              _hover={{ bg: active ? activeBg : 'gray.100' }}
              data-testid={route.testId}
              cursor="pointer"
            >
              <HStack spacing="14px">
                <Box
                  color={active ? activeIcon : inactiveColor}
                  mt="2px"
                >
                  {route.icon}
                </Box>
                <Text
                  color={active ? activeColor : inactiveColor}
                  fontWeight={active ? '600' : '500'}
                  fontSize="sm"
                >
                  {route.name}
                </Text>
              </HStack>
            </Flex>
          </NavLink>
        );
      })}
    </>
  );
}
